import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { AccordionPanel, Row, SelectRange } from 'reaxl';
import FilterTitle from '../FilterTitle';

/**
*  FilterYearRange presents the user with the ability to select a
*/
function FilterYearRange(_ref) {
  let {
    collapsed,
    collapsedTitle,
    filter = {},
    filters = {},
    filtersOrder,
    onOptionChange = () => {},
    onOptionsClear,
    resultCount,
    values = {},
    ...rest
  } = _ref;
  // remove unused props
  delete rest.component;
  const title = /*#__PURE__*/_jsx(FilterTitle, {
    title: filter.label
  }, filter.label);
  return /*#__PURE__*/React.createElement(AccordionPanel, Object.assign({
    "data-cmp": "filterYearRange",
    eventKey: filter.name,
    title: title
  }, rest), /*#__PURE__*/_jsx(Row, {
    className: "padding-horizontal-2"
  }, void 0, /*#__PURE__*/_jsx(SelectRange, {
    inline: true,
    columnProps: {
      xs: 6
    },
    options: filters.yearRange?.options,
    minSelectProps: {
      onChange: event => onOptionChange(event, filters.startYear),
      label: filters.startYear?.label,
      value: values.startYear || ''
    },
    maxSelectProps: {
      onChange: event => onOptionChange(event, filters.endYear),
      label: filters.endYear?.label,
      value: values.endYear || ''
    }
  })));
}
export default FilterYearRange;